import { Input } from "@legacy/Input";
import { Chip } from "@mui/material";
import { styled } from "@mui/material/styles";

export const TextInput = styled(Input)({
  "& input": {
    cursor: "pointer",
  },
});

export const ChipButton = styled(Chip)({
  cursor: "pointer",
  "& > span": {
    display: "flex",
    alignItems: "center",
  },
});
